// اندپوینت‌های گزارش (Eram · ReportController).
// همه POST هستند و بدنه‌ی مشترک ReportModel.Request می‌گیرند.
const report = {
  // داشبورد
  overview: 'report/overview',
  alerts: 'report/alerts',
  capabilities: 'report/capabilities',

  // فروش
  salesTrend: 'report/sales/trend',
  salesByBank: 'report/sales/by-bank',
  salesByStatus: 'report/sales/by-status',
  salesByShipping: 'report/sales/by-shipping',
  salesByProvince: 'report/sales/by-province',
  salesHeatmap: 'report/sales/heatmap',
  salesFunnel: 'report/sales/funnel',

  // سبد رهاشده و تخفیف
  abandonedTrend: 'report/abandoned/trend',
  abandonedRecovery: 'report/abandoned/recovery',
  couponPerformance: 'report/coupon/performance',

  // محصول
  productTop: 'report/product/top',
  productByCategory: 'report/product/by-category',
  productByBrand: 'report/product/by-brand',
  productConversion: 'report/product/conversion',
  productSlowMovers: 'report/product/slow-movers',
  productStock: 'report/product/stock',
  productTrend: 'report/product/trend',
  productBuyers: 'report/product/buyers',

  // مشتری
  customerAcquisition: 'report/customer/acquisition',
  customerCohort: 'report/customer/cohort',
  customerRfm: 'report/customer/rfm',
  customerTop: 'report/customer/top',
  customerDemographics: 'report/customer/demographics',
  customerSummary: 'report/customer/summary',

  // ترافیک و محتوا
  // trafficOptions گزینه‌های مجاز فیلترها را می‌دهد؛ بقیه بدنه‌ی
  // ReportModel.TrafficRequest می‌گیرند (فیلتر + بازه).
  trafficOptions: 'report/traffic/options',
  trafficSite: 'report/traffic/site',
  trafficContent: 'report/traffic/content',
  trafficReferrers: 'report/traffic/referrers',
  trafficPages: 'report/traffic/pages',
  trafficDevices: 'report/traffic/devices',
  trafficPlatforms: 'report/traffic/platforms',
  trafficBots: 'report/traffic/bots',
  trafficStatus: 'report/traffic/status',
  trafficLog: 'report/traffic/log',
  trafficLogDetail: 'report/traffic/log-detail',
  contentTopBlogs: 'report/content/top-blogs',
  contentPublishing: 'report/content/publishing',
  contentPending: 'report/content/pending',

  // سرنخ و خدمات
  leadTrend: 'report/lead/trend',
  leadBySource: 'report/lead/by-source',
  leadByStatus: 'report/lead/by-status',
  dutyTrend: 'report/duty/trend',
  dutyByDuty: 'report/duty/by-duty',

  // عملیاتی
  operationHealth: 'report/operation/health',
  operationErrors: 'report/operation/errors',
}
export default report
